import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
  WithStyles,
  createStyles,
  Button,
  Typography,
  Grid,
} from '@material-ui/core';
import {
  CloseOutlined as CloseIcon,
  FileCopy as CopyIcon,
} from '@material-ui/icons';
import { MyPATIconButton, MyPATDialog } from './components/common';

const styles = (theme: Theme) => createStyles({
  testLabel: {
    ...theme.typography.caption,
    color: theme.palette.primary.main,
    display: 'inline-block',
    marginLeft: theme.spacing.unit,
    padding: `0 ${theme.spacing.unit}px`,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 2,
  },
  testMarks: {
    display: 'inline-block',
    marginRight: theme.spacing.unit,
  }
});

interface Props extends WithStyles<typeof styles> {
}
interface States {
  isDeleteDialogOpen: boolean,
  isPreviewTestTempleteOpen: boolean,
}

class DialogDemo extends Component<Props, States> {
  state = {
    isDeleteDialogOpen: false,
    isPreviewTestTempleteOpen: false,
  };

  handleConfirmDeleteOpen = (e: any) => this.setState({ isDeleteDialogOpen: true });
  handleConfirmDeleteClose = (e: any) => this.setState({ isDeleteDialogOpen: false });

  handlePreviewTestTemplateOpen = (e: any) => this.setState({ isPreviewTestTempleteOpen: true });
  handlePreviewTestTemplateClose = (e: any) => this.setState({ isPreviewTestTempleteOpen: false });

  render() {
    const { classes } = this.props;

    return (
      <div style={{ padding: 16 }}>
        <Button variant="outlined" onClick={this.handleConfirmDeleteOpen.bind(this)}>
          Confirm Delete
        </Button>
        <br /><br />
        <Button variant="outlined" onClick={this.handlePreviewTestTemplateOpen.bind(this)}>
          Preview Test Template (Header)
        </Button>

        {/* confirm delete dialog */}
        <MyPATDialog
          dialogOpen={this.state.isDeleteDialogOpen}
          otherDialogProps={{
            fullWidth: true,
            maxWidth: 'sm',
          }}
          customDialogActions={
            <>
              <Button color="primary">Delete</Button>
              <Button
                variant="contained" color="primary"
                onClick={this.handleConfirmDeleteClose.bind(this)}>
                Cancel
              </Button>
            </>
          }
        >
          <Typography variant="body1">
            <strong>Are you sure you want to delete "Full test 1" permanently?</strong>
          </Typography>
        </MyPATDialog>
        {/* confirm delete dialog */}

        {/* confirm preview test template dialog */}
        <MyPATDialog
          dialogOpen={this.state.isPreviewTestTempleteOpen}
          otherDialogProps={{
            fullWidth: true,
            maxWidth: 'md',
            scroll: 'body',
          }}
          customDialogTitle={
            <>
              <Grid container justify="space-between" alignItems="center">

                <Grid item xs={5}>
                  <Grid container alignItems="center">
                    <Typography variant="h5" noWrap>Full Test JEE Main - 1</Typography>
                    <Typography className={classes.testLabel}>JEEM</Typography>
                  </Grid>
                </Grid>

                <Grid item xs="auto">
                  <Typography variant="body1" className={classes.testMarks}>
                    Marks: 360
                  </Typography>

                  <Button variant="outlined">
                    <CopyIcon /> Copy
                  </Button>

                  <Button variant="contained" color="primary">
                    Edit
                  </Button>

                  <MyPATIconButton buttonVariant="flat"
                    onClick={this.handlePreviewTestTemplateClose.bind(this)}>
                    <CloseIcon />
                  </MyPATIconButton>
                </Grid>
              </Grid>
            </>
          }
        >
          <Typography variant="body1">
            Body of the dialog
          </Typography>
        </MyPATDialog>
        {/* confirm preview test template dialog */}
      </div>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(DialogDemo);